window.dn = window.dn || {};

(function (tag, $, undefined)
{
    /** 
     * Used in response to the Upsert() method
     *  
     * Keep this in sync with C# Tag.TagAction enum.
    */
    tag.TagAction = {
        None:       0,
        Created:    1,
        Updated:    2,
        Failed:     3
    };

    /** 
     * The event that has led to the tag being applied, e.g. a Downvote, Upvote, or Bookmark.
     * Or if the tag was attached "manually" with no other leading event, None.
     *  
     * Keep this in sync with C# Tag.TagEvent enum.
    */
    tag.TagEvent = {
        None:           0,
        Bookmark:       1,
        BookmarkOff:    2,
        Downvote:       3,
        DownvoteOff:    4,
        Upvote:         5,
        UpvoteOff:      6,
        IgnoreVX:       7
    };

    /** 
     * The sentiment of a tag, negative, neutral, or positive.
     *  
     * Keep this in sync with C# Tag.TagSentiment enum.
    */
    tag.TagSentiment = {
        IgnoreVX:   -2,
        Negative:   -1,
        Neutral:     0,
        Positive:    1
    };

    /**
     * Messaging to be shown in the tag editing popover, depending on the tag event.
     */
    tag.TagMessages = {};
    tag.TagMessages[tag.TagEvent.None] = '';
    tag.TagMessages[tag.TagEvent.Bookmark] = ' for your bookmark';
    tag.TagMessages[tag.TagEvent.BookmarkOff] = '';
    tag.TagMessages[tag.TagEvent.Downvote] = ' to explain your vote';
    tag.TagMessages[tag.TagEvent.DownvoteOff] = '';
    tag.TagMessages[tag.TagEvent.Upvote] = ' to explain your vote';
    tag.TagMessages[tag.TagEvent.UpvoteOff] = '';
    tag.TagMessages[tag.TagEvent.IgnoreVX] = ' to explain why you disabled searching on the suggested vehicles';

    /**
     * Holds a reference to any open popover editor.
     */
    tag.CurrentEditor = null;

    /**
     * Holds the current tagging event, if any.
     */
    tag.CurrentEvent = tag.TagEvent.None;

    /**
     * Holds the current message being tagged, if any.
     */
    tag.CurrentMessageKey = null;

    /**
     * Holds the current query being tagged, if any.
     */
    tag.CurrentQueryKey = null;

    /**
     * Holds the current Selectize entry box.
     */
    tag.CurrentSelectize = null;

    /**
     * This is where we'll save the original list of tags the user has supplied, if any,
     * so that we can detect if any changes have been made, so we can decide whether or
     * not to enable the Save button.
     */
    tag.CurrentTags = [];

    /**
     * The DOM identifier used for the Edit Tags modal dialog, and prefix for related elements.
     */
    tag.EditTagsId = "dn-edit-tags";

    /**
     * Create or update tags.
     * 
     * @param {string}  opt.name        - The name of the tag to create.
     * @param {int}     opt.tagEvent    - The event that led to this tag request, e.g. dn.tag.TagEvent.Upvote, 
     *                                    Downvote, or Bookmark.
     * @param {func}    opt.onSuccess   - Callback function we'll pass the wallet info to.
     * @param {func}    opt.onFailure   - (Optional) callback function we'll pass any failure info to.
     * @param {func}    opt.onSaveTag   - (Optional) callback functiomn we'll pass the tag info to, or dn.message.Tag gets called.
     */
    tag.Create = function(opt) 
    {
        $.postJSON('/api/v1/tag', 
        {
            Name: opt.name,
            TagEvent: opt.tagEvent
        })
        .done(function(tag) 
        {
            opt.onSuccess(tag);
        })
        .fail(function(xhr, textStatus, errorThrown) 
        {
            if (opt.onFailure)
            {
                opt.onFailure(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * Internal function called when something has changed on the "Add Tags" form and
     * we want to see whether or not we should be offering a Save button, or a Close button.
     */
    function checkEnableTagSaveButton(opt, identifier, element)
    {
        // See if their old tags match the new tags (any order), so that we know
        // whether or not to show a Save button or a Cancel button.
        var tagsChanged = false;

        tag.CurrentSelectize.items.forEach(function(item, index) 
        {
            if ($.inArray(item, tag.CurrentTags) === -1)
            {
                // didn't find this item, flag tags as changed
                tagsChanged = true;
            }
        });

        if (!tagsChanged)
        {
            // now check the reverse, any items in tag.CurrentTags that are NOT in the editor window?
            tag.CurrentTags.forEach(function(item, index) 
            {
                if ($.inArray(item, tag.CurrentSelectize.items) === -1)
                {
                    // didn't find this item, flag tags as changed
                    tagsChanged = true;
                }
            });
        }

        if (tagsChanged)
        {
            // Convert Cancel button to Save button
            $("button.dn-save-tags-button").addClass('btn-success').removeClass('btn-secondary').off('click').click(function(e) 
            {
                var userTags = dn.text.Split($('#' + tag.EditTagsId).val(), ",");

                // Show spinner on the button, hide the button text (except from screen readers), and disable the button
                $("button.dn-save-tags-button").addClass("dn-loading").prop('disabled', true);

                (opt.onSaveTag || dn.message.Tag)
                (
                    {
                        messageKey: tag.CurrentMessageKey,
                        tags: userTags,
                        tagEvent: tag.CurrentEvent,
                        queryKey: tag.CurrentQueryKey,
                        onSuccess: function(tagResult)
                        {
                            // Hide spinner on the button, show the button text, and enable the button
                            $("button.dn-save-tags-button").removeClass("dn-loading").prop('disabled', false);

                            if (opt.onSaveTagSuccess)
                            {
                                opt.onSaveTagSuccess(tagResult);
                            }
                            else
                            {
                                // Remove existing tags
                                $('#dn-tags-' + tag.CurrentMessageKey + ' .dn-tag').remove();

                                // Add new set of tags
                                $('#dn-tags-' + tag.CurrentMessageKey).append(tagFormat(tagResult, userTags));

                                // Record the new count of usertags in the DOM
                                $('div.dn-message[data-messagekey="' + tag.CurrentMessageKey + '"]').data('usertags-count', tagResult.UserTags.length);

                                // Remove any existing status badges
                                $('div.dn-message[data-messagekey="' + tag.CurrentMessageKey + '"]').removeClass('dn-message-status-OemNotification dn-message-status-Update dn-message-status-Delay dn-message-status-UnresolvedClosure dn-message-status-Rejection dn-message-status-Failure dn-message-status-Resolution dn-message-status-Success').find('.dn-status-area span.dn-message-status').remove();

                                // Add/remove the status badge as appropriate
                                if (tagResult.MessageStatus > 0)
                                {
                                    var statusNoun = dn.message.StatusNouns[tagResult.MessageStatus];
                                    // The author/type manager has tagged this person's reply with a tag that applies a status to it
                                    if ($('div.dn-message[data-messagekey="' + tag.CurrentMessageKey + '"]').find('.dn-status-area span.dn-message-status-' + statusNoun).length === 0)
                                    {
                                        // Status tag doesn't exist yet for this message, so create it
                                        $('div.dn-message[data-messagekey="' + tag.CurrentMessageKey + '"]').addClass('dn-message-status-' + statusNoun).find('.dn-status-area').prepend('<span class="badge badge-pill dn-message-status dn-message-status-' + statusNoun + '">' + statusNoun + '</span>');
                                    }
                                }

                                dn.message.UpdateRootStatus(tagResult.RootStatus);
                            }

                            // Get rid of the popover
                            if (tag.CurrentEditor)
                            {
                                tag.CurrentEditor.popover('hide');
                            }
                        },
                        onFailure: function(xhr, textStatus, errorThrown)
                        {
                            // Hide spinner on the button, show the button text, and enable the button
                            $("button.dn-save-tags-button").removeClass("dn-loading").prop('disabled', false);

                            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                            {
                                dn.ShowModal({
                                    title: 'Problem Saving Tags',
                                    body: dn.FormatApiError(xhr.responseJSON)
                                });
                            }
                        }
                    }
                );
            })
            .find(".dn-loading-hide").text(opt.labelSave || "Save");

            // Show the "Reset" lightweight button on the popover
            $("span.dn-reset").show();

            // Flag the editor popover as dirty, so we know we need to ask the user if 
            // they want to save their changes or not before removing the popover.
            tag.CurrentEditorDirty = true;
        }
        else
        {
            // Convert Save button to Cancel button
            $("button.dn-save-tags-button").addClass('btn-secondary').removeClass('btn-success').off('click').click(function(e) 
            {
                if (tag.CurrentEditor)
                {
                    tag.CurrentEditor.popover('hide');
                }
            })
            .find(".dn-loading-hide").text("Cancel");

            // Hide the "Reset" lightweight button on the popover
            $("span.dn-reset").hide();

            // Flag the editor popover as clean, so we know it's ok to simply dismiss it when asked
            tag.CurrentEditorDirty = false;
        }
    }

    /**
     * Shows a popover pointing at an element that initiated this request, prompting the
     * user to optionally provide us with some tags to add to a message. Unlike tag.ShowTagger,
     * this method will retrieve any existing tags for this message, and pre-populate the
     * tag editor with them. 
     * 
     * @param {string}  opt.messageKey  - The MessageKey of the message being tagged.
     * @param {element} opt.$element    - The element to point the tagger at when tagging.
     * @param {string}  opt.placement   - right/left/bottom/top placement of the element. Defaults to bottom.
     * @param {int}     opt.tagEvent    - The event that led to this tag request, e.g. dn.tag.TagEvent.Upvote, 
     *                                    Downvote, or Bookmark.
     */
    tag.EditTags = function(opt)
    {
        // Retrieve any tags stored for this message, then call ShowTagger.
        opt.onSuccess = tag.ShowTagger;
        dn.message.GetTags(opt);
    };

    /**
     * Shows a popover pointing at an element that initiated this request, prompting the
     * user to optionally provide us with some tags to add to a message.
     * 
     * @param {string}  opt.messageKey  - (Optional) The MessageKey of the message being tagged, if any.
     * @param {string}  opt.tags        - (Optional) Existing tags to pre-populate the tag editor with, if any.
     * @param {element} opt.$element    - The element to point the tagger at when tagging.
     * @param {string}  opt.placement   - right/left/bottom/top placement of the element. Defaults to bottom.
     * @param {int}     opt.tagEvent    - The event that led to this tag request, e.g. dn.tag.TagEvent.Upvote, 
     *                                    Downvote, or Bookmark.
     */
    tag.ShowTagger = function(opt) 
    {
        tag.CurrentMessageKey = opt.messageKey;
        tag.CurrentEvent = opt.tagEvent;

        // Add a layer that triggers the popover to disappear when clicking anywhere other than the popover
        $('body').append($('<div class="dn-tags-popover-background" style="position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 1038;" id="' + tag.EditTagsId + '-background">').click(function(e) 
        {
            if (!tag.CurrentEditorDirty)
            {
                // Kill the popover only if it's not been changed (aka dirty)
                if (tag.CurrentEditor)
                {
                    tag.CurrentEditor.popover('hide');
                }
                else
                {
                    // this should never happen, but if so, we'll at least clear the background layer
                    $(this).remove();
                }
            }
        }));

        if (tag.CurrentEditor)
        {
            tag.CurrentEditor.popover("hide");
        }

        tag.CurrentEditorDirty = false;

        // Determine if they are adding or editing tags, based on the usertags-count encoded in the DOM
        var action = (opt.tags && opt.tags.UserTags.length > 0) ? 'Edit your' : 'Add';

        tag.CurrentEditor = opt.$element.popover({
            content: '<form id="' + tag.EditTagsId + '-form">\
                <span class="dn-reset text-secondary"><i class="far fa-undo-alt"></i> Reset</span>\
                <label for="' + tag.EditTagsId + '" class="dn-form-label mb-1 text-secondary">' + (opt.title || (action + ' tags' + tag.TagMessages[opt.tagEvent] + '?')) + '</label>\
                <div class="input-group mb-2">\
                    <input name="nameNotSearch" type="text" id="' + tag.EditTagsId + '" class="' + tag.EditTagsId + ' form-control col-12" aria-label="Tags for this message" placeholder="Type or select tags" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="form-control dn-autosuggest-field" data-role="tagsinput"><div class="input-group-append"><button type="button" class="btn btn-secondary dn-save-tags-button" id="' + tag.EditTagsId + '-button"><span class="spinner-border spinner-border-sm dn-loading-show-inline-block" role="status" aria-hidden="true"></span><span class="dn-loading-hide">Cancel</span></button></div>\
                </div>\
            </form>', 
            trigger: 'manual', 
            container: 'body', 
            html: true,
            // NOTE: Any changes to the `content` of this popover needs to comply with the Bootstrap
            // sanitizer settings, defined in the `whitelist` property below.
            whiteList: 
            {
                // See: https://getbootstrap.com/docs/4.3/getting-started/javascript/#sanitizer
                '*': ['class', 'dir', 'id', 'lang', 'role', 'style', 'type', 'aria-label', 'aria-hidden'],
                a: ['target', 'href', 'title', 'rel'],
                button: ['type'],
                div: [],
                i: [],
                form: [],
                input: ['name', 'type', 'placeholder', 'autocomplete', 'autocorrect', 'autocapitalize', 'spellcheck', 'data-role'],
                label: ['for'],
                p: [],
                span: []
            },
            placement: (opt.placement || 'bottom'), 
            template: '<div class="dn-tag-popover popover bg-secondary border border-secondary" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
        });

        tag.CurrentEditor.popover('show')
        .on('hidden.bs.popover', function () 
        { 
            tag.CurrentEditor.popover('dispose');
            tag.CurrentEditor = null;
            tag.CurrentEditorDirty = false;
            tag.CurrentSelectize = null;

            $('.dn-tags-popover-background').remove();
        });

        var options = [];
        var items = [];

        if (opt.tags && opt.tags.UserTags.length > 0)
        {
            options = opt.tags.UserTags;
            items = $.map(opt.tags.UserTags, function (t) { return t.TagId; });
        }

        tag.CurrentSelectize = $('#' + tag.EditTagsId).selectize({
            loadThrottle: dn.constants.WaitForAutosuggest,
            valueField: "TagId",
            searchField: "Name",
            // These next two lines pre-fill any existing tags
            options: options,
            items: items,
            persist: true,
            hideSelected: true,
            selectOnTab: true,
            plugins: ['remove_button', 'restore_on_backspace'],
            mode: 'multi',
            highlight: false,
            maxItems: 10,
            openOnFocus: true,
            closeAfterSelect: false,
            preload: true,
            create: function(input, callback) 
            {
                tag.Create(
                {
                    name: input,
                    tagEvent: opt.tagEvent,
                    onSuccess: function(code) 
                    {
                        callback(code);
                    },
                    onFailure: function(xhr, textStatus, errorThrown) {
                        console.error(errorThrown);
                    }
                });
            },
            createFilter: function (query) 
            {
                // only allow them to add email addresses
                return query.replace(/\b\d+\b/g, '').replace(/[_\-\s]+/g, ' ').replace(dn.constants.RegEx.NonLettersNumbersAndWhiteSpace, '').trim();
            },
            onItemAdd: function (identifier, element) 
            {
                setTimeout(function() {
                    checkEnableTagSaveButton(opt, identifier, element);
                }, 100);
            },
            onItemRemove: function (identifier) 
            {
                setTimeout(function() {
                    checkEnableTagSaveButton(opt, identifier);
                }, 100);
            },
            load: function (query, callback) 
            {
                dn.tag.Query({query: (query || '*'), messageKey: opt.messageKey, tagEvent: opt.tagEvent, onSuccess: function (data) {
                    callback(data);
                }, onError: function (error) {
                    callback();
                }});
            },
            render: 
            {
                option: function (data, escape) 
                {
                    var badge = '';

                    if (data.Status)
                    {
                        // If this tag is associated with a Status, make it look like the badge it will set.
                        badge = 'badge badge-pill dn-message-status dn-message-status-' + dn.message.StatusReverse[data.Status];
                    }

                    return '<div class="dn-tag-choice"><span class="tag-name ' + badge + '">' + escape(data.Name) + '</span></div>';
                },
                option_create: function(data, escape) 
                {
                    var newItem = escape
                    (
                        dn.text.ToTitleCase
                        (
                            (data.input || "")
                            .replace(/\b\d+\b/g, '')
                            .replace(/[_\-\s]+/g, ' ')
                            .replace(dn.constants.RegEx.NonLettersNumbersAndWhiteSpace, '')
                            .trim(),
                            true // preserve acronyms
                        )
                    );

                    if (newItem.lengthInTextElements > dn.constants.MaxLengthUnicodeTagName)
                    {
                        newItem = newItem.substringByTextElements(0, dn.constants.MaxLengthUnicodeTagName);
                    }
                    return '<div class="create">Create Tag <strong>' + newItem + '</strong>&hellip;</div>';
                },
                item: function (data, escape) 
                {
                    return '<div class="dn-tag-box" data-tag-name="' + data.Name + '" data-tag-id="' + data.TagId + '">' + data.Name + '</div>';
                }
            }

        })[0].selectize;

        // Do some things after a brief 100ms delay, so that everything is in position on screen.
        setTimeout(function() 
        {
            checkEnableTagSaveButton(opt);

            // Adjust the max-height on the tag dropdown to use up all available screen space.
            var $tagBox = $('#' + tag.EditTagsId + '-form').find("div.input-group")[0];
            var $dropdownContent = $('#' + tag.EditTagsId + '-form').find(".selectize-dropdown-content");
            $dropdownContent.css('max-height', (window.innerHeight - $tagBox.getBoundingClientRect().bottom));

            // When visible, clicking the Reset link will return the tag box to it's original form
            $('#' + tag.EditTagsId + '-form').find("span.dn-reset").click(function(e) 
            {
                tag.CurrentSelectize.setValue(tag.CurrentTags);
                checkEnableTagSaveButton(opt);
            });

            // Show the default tags for this operation
            dn.tag.CurrentSelectize.focus();

        }, 50);

        tag.CurrentTags = tag.CurrentSelectize.items.slice(); // save this for comparison if they make changes
    };

    /**
     * Format a message's tags, based on whether or not the tag has been used more than once,
     * or the tag has been used by the current viewing user (if any). 
     * 
     * @param {object} tagResponse  - The response from the tagging API call, with new tags associated with this message, 
     *                                with MessageTags, UserTags, and Status properties.
     * @param {array} userTags      - Array of `TagId`s that are being set by the user in this action. Primarily this is
     *                                used for highlighting the tags being set by this user. 
     */
    function tagFormat(tagResponse, userTags)
    {
        var tagList = '';

        tagResponse.MessageTags.forEach(function(tag, index) 
        {
            // Show tags if ANY of the following is true:
            // 
            //  - The tag was used by 2+ taggers, or
            //  - The tag is an official community tag (UserId=0), or
            //  - The viewer is the tagger

            if (tag.NumUses > 1)
            {
                tagList += '<div class="dn-tag ml-0" title="' + tag.Name + ' ' + '(' + tag.NumUses + ')"><span class="' + ($.inArray((tag.TagId + ""), userTags) > -1 ? " dn-highlight-once" : "") + '">' + tag.Name + '</div>';
            }
            else if (dn.constants.TagsOfficial[tag.TagId] === true || tagResponse.UserTags.some(function(t) { return (t.TagId === tag.TagId) }))
            {
                tagList += '<div class="dn-tag ml-0" title="' + tag.Name + '"><span class="' + ($.inArray((tag.TagId + ""), userTags) > -1 ? " dn-highlight-once" : "") + '">' + tag.Name + '</span></div>';
            }
        });

        return tagList;
    }

    /**
     * Get tag autosuggestions by passing a query string of a partial (or whole) tag name.
     * 
     * @param {string} opt.query        - A whole or partial tag name. If '*', all tags will be 
     *                                    returned that match the given event.
     * @param {string} opt.messageKey   - Pass the messagekey of the message potentially being tagged.
     * @param {int} opt.tagEvent        - The event that led to this tag request, e.g. dn.tag.TagEvent.Upvote, 
     *                                    Downvote, or Bookmark.
     * @param {function} opt.onSuccess  - On success, we'll call this function with the returned data.
     * @param {function} opt.onError    - On failure, we'll call this function with the error message.
     */
    tag.Query = function (opt) 
    {
        $.get('/api/v1/tag/query/' + encodeURIComponent(opt.query) + '/' + (opt.messageKey || "*") + (opt.tagEvent ? '/' + opt.tagEvent : ''))
        .done(function (data, textStatus, request) 
        {
            if (opt.onSuccess)
            {
                opt.onSuccess(data);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {
            if (opt.onError)
            {
                opt.onError(errorThrown);
            }
        });
    };

}(window.dn.tag = window.dn.tag || {}, jQuery));
